import { motion } from "framer-motion";
import { Building2, CalendarClock, BadgeCheck, Handshake } from "lucide-react";
import SafeImage from "@/components/SafeImage";
import { IMAGES } from "@/data/images";

const pillars = [
  {
    icon: Building2,
    title: "Prilagođeno vašem objektu",
    desc: "Restoran od 40 mesta, hotel sa 60 soba ili kafić sa 300 salveta dnevno — kreiramo paket koji odgovara upravo vašem obimu i tipu inventara.",
  },
  {
    icon: CalendarClock,
    title: "Fiksan raspored preuzimanja",
    desc: "Dogovaramo tačne dane i sate u sedmici. Naši ljudi dolaze uvek u istom terminu — bez pozivanja, bez čekanja, bez iznenađenja.",
  },
  {
    icon: BadgeCheck,
    title: "Higijenski standardi",
    desc: "Pranje na propisanim temperaturama, razdvajanje toka čistog i prljavog veša, kontrola pH sredstava — sve u skladu sa higijenskim standardima ugostiteljstva.",
  },
  {
    icon: Handshake,
    title: "Transparentna cena",
    desc: "Ugovorena cena po komadu ili po kilogramu, mesečni obračun, jasan izveštaj. Bez skrivenih doplata za preuzimanje, dostavu ili sitne dorade.",
  },
];

export default function ForBusiness() {
  return (
    <section
      id="fur-specialty"
      data-testid="fur-specialty-section"
      className="tw-section relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20 sm:opacity-25">
        <SafeImage
          src={IMAGES.business}
          alt="Luksuzni hotelski enterijer — TOP WASH DOO partner za ugostiteljstvo"
          className="w-full h-full object-cover object-center"
          loading="lazy"
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#030812] via-[#030812]/85 to-[#030812]/40" />
      </div>

      <div
        className="glow-blob"
        style={{
          top: "20%",
          left: "40%",
          width: 500,
          height: 500,
          background: "radial-gradient(circle, #1fa8ff 0%, transparent 60%)",
          opacity: 0.35,
        }}
      />

      <div className="relative z-10 tw-container grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
        <div className="lg:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <div className="overline">04 — Za vaš biznis</div>
            <h2 className="mt-4 md:mt-6 tw-heading-section">
              Vaš objekat radi.
              <br />
              <span className="blue-text font-display italic">Tekstil ne sme da kasni.</span>
            </h2>
            <p className="mt-8 text-[#c8d6ec] text-base md:text-lg leading-relaxed max-w-md">
              Radimo isključivo sa profesionalnim korisnicima — restoranima,
              kafićima, hotelima, pansionima, spa centrima i cateringom. Naš
              tim poznaje ritam smena, sezonske pikove i standarde koje vaš
              gost očekuje u svakom detalju.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
              <a
                href="#contact"
                className="tw-btn w-full sm:w-auto justify-center"
                data-testid="fur-specialty-cta"
              >
                Počnimo saradnju
              </a>
              <a
                href="#contact"
                className="tw-btn-ghost w-full sm:w-auto justify-center"
                data-testid="fur-specialty-secondary"
              >
                Pitajte nas direktno
              </a>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {pillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: i * 0.08 }}
                  data-testid={`fur-pillar-${i}`}
                  className="tw-card p-6 md:p-7"
                >
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#55d0ff]/25 to-[#0b6cc9]/20 border border-[#55d0ff]/30 flex items-center justify-center">
                    <Icon size={22} strokeWidth={1.8} className="text-[#a7e2ff]" />
                  </div>
                  <h3 className="mt-5 font-heading-md text-lg md:text-xl text-white leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-[#a7bcd6] text-sm leading-relaxed">
                    {p.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
